/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<09f7e729af89e2cc42c7bc52398de786>>
 * @relayHash fd012eeb6323993c6ba2996420b398d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4626ca99f08ea07f2905b66971863303d3df73c8762234bc7b9fd03d649e234

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultCombinedQuery$variables = {
  categoryIds?: ReadonlyArray<string> | null | undefined;
  cloudId: string;
  portalIds?: ReadonlyArray<string> | null | undefined;
  queryTerm: string;
  resultLimit?: number | null | undefined;
};
export type searchResultCombinedQuery$data = {
  readonly helpObjectStore: {
    readonly __typename: "HelpObjectStoreQueryApi";
    readonly " $fragmentSpreads": FragmentRefs<"articlesFragment" | "portalsFragment" | "requestFormsFragment">;
  };
};
export type searchResultCombinedQuery = {
  response: searchResultCombinedQuery$data;
  variables: searchResultCombinedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "portalIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryTerm"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resultLimit"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "portalIds",
  "variableName": "portalIds"
},
v9 = {
  "kind": "Variable",
  "name": "queryTerm",
  "variableName": "queryTerm"
},
v10 = {
  "kind": "Variable",
  "name": "resultLimit",
  "variableName": "resultLimit"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchBackend",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayLink",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containerDisplayName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchAlgorithm",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "HelpObjectStoreQueryError",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "searchResultCombinedQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v6/*: any*/),
          "concreteType": "HelpObjectStoreQueryApi",
          "kind": "LinkedField",
          "name": "helpObjectStore",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "requestFormsFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "articlesFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "portalsFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "helpObjectStore"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "searchResultCombinedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "HelpObjectStoreQueryApi",
        "kind": "LinkedField",
        "name": "helpObjectStore",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": "requestForms",
            "args": [
              {
                "fields": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "entityType",
                    "value": "REQUEST_FORM"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "searchInput"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "searchHelpObjects",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "type": "HelpObjectStoreSearchResult",
                "abstractKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "articles",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "categoryIds",
                    "variableName": "categoryIds"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "entityType",
                    "value": "ARTICLE"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "searchInput"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "searchHelpObjects",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v17/*: any*/)
                ],
                "type": "HelpObjectStoreSearchResult",
                "abstractKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "portals",
            "args": [
              {
                "fields": [
                  (v5/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "entityType",
                    "value": "PORTAL"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "searchInput"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "searchHelpObjects",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "type": "HelpObjectStoreSearchResult",
                "abstractKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c4626ca99f08ea07f2905b66971863303d3df73c8762234bc7b9fd03d649e234",
    "metadata": {},
    "name": "searchResultCombinedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dd7924a631b3041722bf7e986d8ef46e";

export default node;
